import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API, Badge, dt, fehler, feld } from "./shared";

const TEILE = { kennzahlen: "Kennzahlen (aktuelles Jahr + Vorjahr)", punkte: "Offene Punkte", beschwerden: "Beschwerden", dokumente: "QM-Dokumentenlenkung", audit_checkliste: "Audit-Checkliste Teilnehmerakten" };

export const QMAuditorPaket = () => {
  const [liste, setListe] = useState([]);
  const [empf, setEmpf] = useState("");
  const [tage, setTage] = useState(14);
  const [teile, setTeile] = useState(Object.keys(TEILE));
  const [busy, setBusy] = useState(false);
  const [neu, setNeu] = useState(null);
  const laden = useCallback(() => axios.get(`${API}/auditor-pakete`).then((r) => setListe(r.data)).catch(fehler), []);
  useEffect(() => { laden(); }, [laden]);
  const erstellen = async (e) => {
    e.preventDefault(); setBusy(true);
    await axios.post(`${API}/auditor-pakete`, { empfaenger: empf, gueltig_tage: tage, bestandteile: teile }).then((r) => { setNeu(r.data); laden(); }).catch(fehler);
    setBusy(false);
  };
  const sperren = (id) => window.confirm("Link sofort sperren?") && axios.put(`${API}/auditor-pakete/${id}/sperren`).then(() => { toast.success("Gesperrt"); laden(); }).catch(fehler);
  const jetzt = new Date().toISOString();
  return (
    <div className="space-y-4" data-testid="qm-auditor">
      <form onSubmit={erstellen} className="bg-white rounded-xl p-4 border border-[#F0E6DC] space-y-3">
        <div className="grid md:grid-cols-3 gap-2">
          <input className={`${feld} md:col-span-2`} placeholder="Empfänger (z. B. Auditorin, Zertifizierungsstelle) *" required value={empf} onChange={(e) => setEmpf(e.target.value)} data-testid="auditor-empfaenger" />
          <label className="text-sm flex items-center gap-2">Gültig <input className="w-20 rounded-md border border-[#E0D6CA] px-2 py-1.5 text-sm" type="number" min={1} max={60} value={tage} onChange={(e) => setTage(Number(e.target.value))} data-testid="auditor-tage" /> Tage</label>
        </div>
        <div className="flex flex-wrap gap-3">
          {Object.entries(TEILE).map(([k, l]) => (
            <label key={k} className="text-sm flex items-center gap-1.5"><input type="checkbox" checked={teile.includes(k)} onChange={(e) => setTeile(e.target.checked ? [...teile, k] : teile.filter((t) => t !== k))} data-testid={`auditor-teil-${k}`} />{l}</label>
          ))}
        </div>
        <Button type="submit" size="sm" disabled={busy || !teile.length} className="bg-[#9A3B2E] hover:bg-[#7F2F25]" data-testid="auditor-erstellen"><Lock size={14} className="mr-1" />{busy ? "Erstelle Paket…" : "Verschlüsseltes Paket erstellen"}</Button>
      </form>
      {neu && (
        <div className="rounded-xl border-2 border-[#4F6650] bg-[#F3F7F1] p-4 text-sm space-y-1" data-testid="auditor-neu">
          <p className="font-semibold">Paket erstellt – Link und Passwort bitte auf getrennten Wegen weitergeben.</p>
          <p>Link: <span className="break-all select-all" data-testid="auditor-link">{neu.link}</span></p>
          <p>Passwort: <span className="font-mono text-base select-all" data-testid="auditor-passwort">{neu.passwort}</span> <span className="text-xs text-[#8E7B71]">(wird nur jetzt angezeigt)</span></p>
          <p className="text-xs text-[#78716c]">Gültig bis {dt(neu.ablauf)} · {neu.dateien.length} Dateien</p>
        </div>
      )}
      <div className="bg-white rounded-xl border border-[#F0E6DC] divide-y divide-[#F6E3DA]">
        {liste.map((p) => {
          const aktiv = p.ablauf > jetzt;
          return (
            <div key={p.id} className="p-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`auditor-paket-${p.id}`}>
              <span className="font-medium">{p.empfaenger}</span>
              <span className="text-[#78716c]">erstellt {dt(p.erstellt_am)} von {p.erstellt_von}</span>
              <span className="text-[#78716c]">{p.downloads.length}× heruntergeladen</span>
              <span className="ml-auto flex items-center gap-2">
                <Badge ton={aktiv ? "gruen" : "grau"}>{aktiv ? `gültig bis ${dt(p.ablauf)}` : "abgelaufen"}</Badge>
                {aktiv && <Button size="sm" variant="ghost" onClick={() => sperren(p.id)} data-testid={`auditor-sperren-${p.id}`}>Sperren</Button>}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
